module.exports = __webpack_public_path__ + "static/media/tomiris.5db56712.jpg";